export class Auth {
    token?: any;
    factory?: any;
    user?: any;
}
